import { forgotPassword } from "../../store/features/auth/authApi";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Card, Container, Form } from "react-bootstrap";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await forgotPassword(values.email);
      toast.success(
        "We’ve sent you a password reset link. Please check your email."
      );
      resetForm();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error resetting password");
    } finally {
      setSubmitting(false);
    }
  };

  const initialValues = { email: "" };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card style={{ width: "100%", maxWidth: "400px" }} className="p-4 shadow">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
          alt="abarka-logo"
          className="login-logo"
        />

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleSubmit,
            touched,
            errors,
            isSubmitting,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  isInvalid={touched.email && errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                type="submit"
                className="w-100"
                variant="primary"
                disabled={isSubmitting}
              >
                Send Reset Link
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
